export const TELEGRAM_URL =
  "https://t.me/sabrinaaaaa99?text=Halo%20Sabrina%2C%20bantu%20saya%20bergabung%20dengan%20program%20%5BSelfRebate%20%2415%2FTrade%20and%20Claim%5D.";
export const REGISTER_URL = "https://ma.valetax-indonesia.com/p/6511742";
export const REBATE_PER_LOT = 15;
export const BRAND = "Trade & Claim × Self Rebate";

export const HERO_STAGE_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/2e9eee04-5107-4ac8-893c-56909775b422/images/3f7cd7159d3d59e483432e5212863c9f78dea91eb0c56d78e599401913b5b90c.jpeg";

export const PRIZES = [
  {
    id: "mercedes",
    name: "Mobil Mercedes-Benz",
    lots: 16500,
    lotsLabel: "16.500",
    tag: "Grand Prize",
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e9eee04-5107-4ac8-893c-56909775b422/images/de26fa29f3c7272abd2eded09f60d3da60f7bbe9b13935d87b5a14be40e9ef2b.jpeg",
  },
  {
    id: "ninja250",
    name: "Motor Kawasaki Ninja 250cc",
    lots: 2800,
    lotsLabel: "2.800",
    tag: "Sportbike",
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e9eee04-5107-4ac8-893c-56909775b422/images/b2632b70f192c6ac0bdd1ad5496081dedc939019fd8c6fb28cac7b05a86e6aa6.jpeg",
  },
  {
    id: "tokyo",
    name: "Liburan ke Tokyo",
    lots: 2250,
    lotsLabel: "2.250",
    tag: "Trip",
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e9eee04-5107-4ac8-893c-56909775b422/images/10507702b669a36d679f58466a59bae7572f5b9f9720d4719991f3fd0c8d5f0f.jpeg",
  },
  {
    id: "iphone-duo",
    name: "iPhone Duo",
    lots: 1800,
    lotsLabel: "1.800",
    tag: "Gadget",
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e9eee04-5107-4ac8-893c-56909775b422/images/4e9c370c39380502c12a77b204b4d070d25481106f29f1a7ab4bbecca0d11f3c.jpeg",
  },
  {
    id: "vario125",
    name: "Motor Honda Vario 125cc",
    lots: 900,
    lotsLabel: "900",
    tag: "Skutik",
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e9eee04-5107-4ac8-893c-56909775b422/images/fedd58143db115c8e9d823ff8699b9a2ab892d2c1a9a910b3c8e7a52b42e9c28.jpeg",
  },
  {
    id: "macbook",
    name: "MacBook",
    lots: 680,
    lotsLabel: "680",
    tag: "Gadget",
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e9eee04-5107-4ac8-893c-56909775b422/images/6bb73bab7fe028bcc294214c5457b0d2a66e6633d09588b15cfb21cc99375532.jpeg",
  },
  {
    id: "iphone18promax",
    name: "iPhone 18 Pro Max",
    lots: 680,
    lotsLabel: "680",
    tag: "Gadget",
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e9eee04-5107-4ac8-893c-56909775b422/images/cf04e65068c0b48524f325092a3f1ca5bf7c967724ea575ebd2042f3d83f0e2d.jpeg",
  },
  {
    id: "apple-watch",
    name: "Apple Watch S12",
    lots: 230,
    lotsLabel: "230",
    tag: "Wearable",
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e9eee04-5107-4ac8-893c-56909775b422/images/6eb5a650333a6e3a0641f54d8eceba7c5cefa606c2c2043d403cd62332c1aa97.jpeg",
  },
  {
    id: "ipad",
    name: "iPad",
    lots: 180,
    lotsLabel: "180",
    tag: "Gadget",
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e9eee04-5107-4ac8-893c-56909775b422/images/61fef2567731946b9ac47f8809a079ced34ac12cb6f1ea649cd15599b39f6c8c.jpeg",
  },
  {
    id: "airpods",
    name: "AirPods Pro 3",
    lots: 110,
    lotsLabel: "110",
    tag: "Audio",
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e9eee04-5107-4ac8-893c-56909775b422/images/1a8df886e2cbadba92ac96a1b21c86477fd676d4fb6718737de669ca91e2ff8b.jpeg",
  },
  {
    id: "gold-bar",
    name: "Gold Bar 1 gram",
    lots: 60,
    lotsLabel: "60",
    tag: "Emas",
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e9eee04-5107-4ac8-893c-56909775b422/images/1b87457bf029292c1f9242fa81e4c513d137ab7de48425964ad540593ebc5270.jpeg",
  },
  {
    id: "cash-22jt",
    name: "Uang Tunai Rp2.200.000",
    lots: 40,
    lotsLabel: "40",
    tag: "Uang Tunai",
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e9eee04-5107-4ac8-893c-56909775b422/images/4655c5a1ce6ff632e770b6eab0a59bd4b17a3d3cd4610285ee2eb5429258bb2e.jpeg",
  },
  {
    id: "cash-1jt",
    name: "Uang Tunai Rp1.000.000",
    lots: 20,
    lotsLabel: "20",
    tag: "Uang Tunai",
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e9eee04-5107-4ac8-893c-56909775b422/images/f72bf91964640f39a7319d6357019ff15505673f8df598a5bff62ddd21e6546d.jpeg",
  },
];

export const MARQUEE_ITEMS = [
  "MERCEDES-BENZ · 16.500 LOT",
  "REBATE US$15 / LOT",
  "KAWASAKI NINJA 250 · 2.800 LOT",
  "LIBURAN KE TOKYO · 2.250 LOT",
  "IPHONE DUO · 1.800 LOT",
  "HONDA VARIO 125 · 900 LOT",
  "MACBOOK · 680 LOT",
  "APPLE WATCH · 230 LOT",
  "GOLD BAR · 60 LOT",
  "HADIAH MULAI 20 LOT",
];

export const formatUSD = (n) =>
  `US$${Math.round(n).toLocaleString("id-ID")}`;

export const scrollToSection = (selector) => {
  const el = document.querySelector(selector);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -76, duration: 1.3 });
  else el.scrollIntoView({ behavior: "smooth" });
};
